import type * as schemas from "@common/schemas/v2";
import * as models from "@common/models/v2";
import { BaseStep } from "./base";
import { StepActions } from "./step";
import { autorun, computed, makeObservable, observable, override, reaction, runInAction } from "mobx";
import { FlowFlexibility } from "@common/schemas";

export class SleepStep extends BaseStep {
  attributes: models.SleepStepAttributes;
  actions: StepActions;
  duration: number = 0;
  isWaiting: boolean = false;
  isTimedout: boolean = false;

  constructor(step: schemas.Step, actions: StepActions, flowFlexibility: FlowFlexibility) {
    super(step, actions, flowFlexibility);
    this.attributes = new models.SleepStepAttributes(step.attributes as schemas.SleepStepAttributes);
    this.actions = actions;
    this.duration = this.attributes.duration;
    this.isTimedout = false;
    makeObservable(this, {
      isWaiting: observable,
      isTimedout: observable,
      isBlocking: override,
    });
  }

  async run() {
    super.run();
    if (!this.isWaiting) {
      this.isWaiting = true;

      const sleep = new Promise((resolve) => setTimeout(resolve, this.duration));
      sleep.then(() => {
        runInAction(() => {
          this.isWaiting = false;
        });
      });
    }
  }

  get isBlocking() {
    return this.isWaiting;
  }

  get isBlockingStepType() {
    return true;
  }
}
